export default __webpack_public_path__ + "static/media/displayImage.26252081.jpg";